<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Plan de Cuentas">

            <tree
              :key="key"
              ref="tree" 
              :data="nodos"
              :options="treeOptions"
              @node:selected="selected"/>

            <!-- <b-tree-view 
              :key="key"
              ref="tree" 
              :data="nodos"
              :renameNodeOnDblClick="false"
              :contextMenu="true"
              :contextMenuItems="[
                { 
                  code: 'edit', 
                  label: 'Editar' 
                }, 
                { 
                  code: 'delete', 
                  label: 'Borrar' 
                }]"
              @nodeSelect="selected"
              @contextMenuItemSelect="contextMenuItemSelected">
            </b-tree-view> -->

            <!-- <v-tree
              :key="key"
              ref="tree" 
              @selected="selected"
              :data="nodos"
              :data-format="dataFormat"
              :expand-all="false">
            </v-tree> -->
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregarCuenta">
            <i class="fa fa-plus"></i>Agregar Cuenta</b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-item @click.stop="agregar" v-if="addChild">
            <i class="fa fa-plus"></i>{{ addChildLegend }}</b-dropdown-item>
          <b-dropdown-item @click.stop="editar" v-if="selectedNode">
            <i class="fa fa-edit"></i>{{ editLegend }}</b-dropdown-item>
          <b-dropdown-item @click.stop="borrar" v-if="selectedNode">
            <i class="fa fa-remove"></i>{{ deleteLegend }}</b-dropdown-item>
          <b-dropdown-divider v-if="addChild || selectedNode" />
          <b-dropdown-item @click.stop="exportXLS">
            <i class="fa fa-file-excel-o"></i>Exportar Plan de Cuentas</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="cuentaModal" 
        title="Datos de la Cuenta"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cuenta
        :cuentaId="cuentaId"
        @close="closeCuenta">
      </app-cuenta>  
    </b-modal>

    <b-modal ref="rubroModal" 
        title="Datos del Rubro"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-rubro
        :cuentaId="cuentaId"
        :rubroId="rubroId"
        @close="closeRubro">
      </app-rubro>  
    </b-modal>

    <b-modal ref="subrubroModal" 
        title="Datos del Subrubro"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-subrubro
        :rubroId="rubroId"
        :subrubroId="subrubroId"
        @close="closeSubrubro">
      </app-subrubro>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Cuenta from './Cuenta.vue';
import Rubro from './Rubro.vue';
import Subrubro from './Subrubro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import export_xls from '../../mixins/export_xls';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  // getterType: 'plancuentas/getField',
  // mutationType: 'plancuentas/updateField',
  getterType: 'planCuentas/getField',
  mutationType: 'planCuentas/updateField',
});

export default {
  name: 'PlanCuentas',
  components: {
    appABMButton: ABMButtons,
    appCuenta: Cuenta,
    appRubro: Rubro,
    appSubrubro: Subrubro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
    export_xls
  ],
  data() {
    return {
      key: 0,
      selectedNode: null,
      cuentaId: 0,
      rubroId: 0,
      subrubroId: 0,

      treeOptions: {
        multiple: false,
        checkBox: false,
      }
    } 
  },
  computed: {
    ...mapFields([
      'cuentas',
      'nodos',
    ]),
    addChild() {
      if (this.selectedNode) {
        if (this.selectedNode.data.level == 0 | this.selectedNode.data.level == 1) {
          return true;
        }
      }
      return false;
    },
    addChildLegend() {
      if (this.selectedNode) {
        if (this.selectedNode.data.level == 0) {
          return 'Agregar Rubro';
        } else if (this.selectedNode.data.level == 1) {
          return 'Agregar Subrubro';
        }
      }
      return '';
    },
    editLegend() {
      let editLegend = '';
      if (this.selectedNode) {
        switch (this.selectedNode.data.level) {
          case 0:
            editLegend = 'Editar Cuenta'
            break;
        
          case 1:
            editLegend = 'Editar Rubro'
            break;

          case 2:
            editLegend = 'Editar Subrubro'
            break;
        }
      }
      return editLegend;
    },
    deleteLegend() {
      let deleteLegend = '';
      if (this.selectedNode) {
        switch (this.selectedNode.data.level) {
          case 0:
            deleteLegend = 'Borrar Cuenta'
            break;
        
          case 1:
            deleteLegend = 'Borrar Rubro'
            break;

          case 2:
            deleteLegend = 'Borrar Subrubro'
            break;
        }
      }
      return deleteLegend;
    }
  },
  created() {
    this.getPlanCuentas();
  },  
  methods: {
    dataFormat() {
    },
    selected(node) {
      this.selectedNode = node;
    },
    getPlanCuentas() {
      this.showSpinner();
      this.$store.dispatch('planCuentas/inicializarPlanCuentas')
        .then(() => this.key++ )
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    agregarCuenta() {
      this.cuentaId = 0;
      this.$refs.cuentaModal.show();
    },
    agregar() {
      if (this.selectedNode) {
        if (this.selectedNode.data.level == 0) {
          this.cuentaId = this.selectedNode.data.cuentaId;
          this.rubroId = 0;
          this.$refs.rubroModal.show();
        } else if (this.selectedNode.data.level == 1) {
          this.rubroId = this.selectedNode.data.rubroId;
          this.subrubroId = 0;
          this.$refs.subrubroModal.show();
        }
      }
    },
    editar() {
      if (this.selectedNode) {
        switch (this.selectedNode.data.level) {
          case 0:
            this.cuentaId = this.selectedNode.data.cuentaId;
            this.$refs.cuentaModal.show();
            break;
        
          case 1:
            this.cuentaId = this.selectedNode.data.cuentaId;
            this.rubroId = this.selectedNode.data.rubroId;
            this.$refs.rubroModal.show();
            break;

          case 2:
            this.rubroId = this.selectedNode.data.rubroId;
            this.subrubroId = this.selectedNode.data.subrubroId;
            this.$refs.subrubroModal.show();
            break;
        }
      }
    },
    borrar() {
      if (this.selectedNode) {
        let confirmMsj;
        let confirmAction;
        switch (this.selectedNode.data.level) {
          case 0:
            confirmMsj = '¿Desea borrar la cuenta seleccionada?';
            confirmAction = this.deleteCuenta.bind(this, this.selectedNode.data.cuentaId);
            break;
        
          case 1:
            confirmMsj = '¿Desea borrar el rubro seleccionado?';
            confirmAction = this.deleteRubro.bind(this, this.selectedNode.data.rubroId);
            break;

          case 2:
            confirmMsj = '¿Desea borrar el subrubro seleccionado?';
            confirmAction = this.deleteSubrubro.bind(this, this.selectedNode.data.subrubroId);
            break;
        }

        this.showModalConfirm(confirmMsj, 
          confirmAction, 'Si', null, 'No'); 
      }
    },
    deleteCuenta(cuentaId) {
      this.showSpinner();
      this.$store.dispatch('cuenta/delete', cuentaId)
        .then( () => {
          this.showModalMsj ('La cuenta se borró con éxito.', null, null, 'light')
          this.getPlanCuentas();
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    deleteRubro(rubroId) {
      this.showSpinner();
      this.$store.dispatch('rubro/delete', rubroId)
        .then( () => {
          this.showModalMsj ('El rubro se borró con éxito.', null, null, 'light')
          this.getPlanCuentas();
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    deleteSubrubro(subrubroId) {
      this.showSpinner();
      this.$store.dispatch('subrubro/delete', subrubroId)
        .then( () => {
          this.showModalMsj ('El subrubro se borró con éxito.', null, null, 'light')
          this.getPlanCuentas();
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    closeCuenta(actualizado) {
      if (actualizado) {
        this.getPlanCuentas();
      }
      this.$refs.cuentaModal.hide();
    }, 
    closeRubro(actualizado) {
      if (actualizado) {
        this.getPlanCuentas();
      }
      this.$refs.rubroModal.hide();
    }, 
    closeSubrubro(actualizado) {
      if (actualizado) {
        this.getPlanCuentas();
      }
      this.$refs.subrubroModal.hide();
    },
    exportXLS() {
      let exportXls = Boolean(false);
      if (this.cuentas) {
        if (this.cuentas.length != 0) {
          exportXls = true;
        }
      }
      if (exportXls) {
        this.exportXLSPlanCuentas(this.cuentas);
      } else {
        this.showModalMsj ('No hay datos para exportar.', null, null, 'danger')
      }
    },                
  },
}
</script>

<style>
  .ztree li span.button.ico_open,
  .ztree li span.button.ico_close,
  .ztree li span.button.ico_docu {
    display: none;
  }
</style>
